export const SET_PROJECT_CONFIG = 'config/SET_PROJECT_CONFIG';
